import { render, staticRenderFns } from "./ItemsPatrimony.vue?vue&type=template&id=ffa39aec&scoped=true&"
import script from "./ItemsPatrimony.vue?vue&type=script&lang=js&"
export * from "./ItemsPatrimony.vue?vue&type=script&lang=js&"
import style0 from "./ItemsPatrimony.vue?vue&type=style&index=0&id=ffa39aec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa39aec",
  null
  
)

export default component.exports